module.exports = __webpack_public_path__ + "img/product_standard_inactive_mobile.4690020d.png";